module.exports = __webpack_public_path__ + "img/storeReview.9b3886df.png";